/*@flow*/
import useCachedQuery from 'lib/useCachedQuery';
import { GET_QUOTAS } from './queries';
import * as I from 'immutable';

export default (
  name: string
): {| error: Array<string>, hasRoom: boolean, loading: boolean |} => {
  const value = useCachedQuery(GET_QUOTAS);
  const { data, loading, error } = value;
  if (loading) {
    return { loading: true, hasRoom: false, error: [] };
  }
  const quotas = I.getIn(data, ['me', 'quotas'], []);
  const quota = quotas.find((v) => v.name === name);

  if (!quota) {
    return {
      loading: false,
      hasRoom: false,
      error: ['No such quota: ' + name],
    };
  }
  const quotaSize = I.get(quota, 'size', 0);
  const quotaCap = I.get(quota, 'capacity', 0);
  const hasRoom = quotaSize >= 0 && quotaSize < quotaCap;
  return {
    loading: false,
    hasRoom,
    error: error ? error.map((v) => v.message) : [],
  };
};
